import { CompositeLayer } from '@deck.gl/core';
import { IconLayer, ScatterplotLayer } from '@deck.gl/layers';

export const ALERT_ICONS_LAYER = 'alert-icons-layer';
const MOST_RECENT_ALERTS_CIRCLE_LAYER = 'most-recent-alerts-circle-layer';
const HISTORIC_ALERTS_CIRCLE_LAYER = 'historic-alerts-circle-layer';

class AlertsLayer extends CompositeLayer {
  initializeState() {
    super.initializeState();
  }

  onHover(info, pickingEvent) {
    // This bugfix suppressed the first hover after a click which causes
    // features like popovers to close immediately after a click.
    if (this.state.isClicked) {
      this.state.isClicked = false;
      return;
    }
    super.onHover(info, pickingEvent);
  }

  onClick(info, pickingEvent) {
    this.state.isClicked = true;
    super.onClick(info, pickingEvent);
  }

  renderLayers() {
    const {
      data,
      alertsIconLayerProps,
      mostRecentCircleLayerProps,
      historicCircleLayerProps,
      onHover,
      onClick,
    } = this.props;
    const alertsIconLayer = new IconLayer(
      this.getSubLayerProps({
        id: ALERT_ICONS_LAYER,
        data: data,
        parameters: {
          depthTest: false,
        },
        onHover,
        onClick,
        ...alertsIconLayerProps,
      }),
    );
    const mostRecentCircleLayer = new ScatterplotLayer(
      this.getSubLayerProps({
        id: MOST_RECENT_ALERTS_CIRCLE_LAYER,
        data: mostRecentCircleLayerProps.data,
        parameters: {
          depthTest: false,
        },
        ...mostRecentCircleLayerProps,
      }),
    );
    const historicCircleLayer = new ScatterplotLayer(
      this.getSubLayerProps({
        id: HISTORIC_ALERTS_CIRCLE_LAYER,
        data: historicCircleLayerProps.data,
        parameters: {
          depthTest: false,
        },
        ...historicCircleLayerProps,
      }),
    );

    return [mostRecentCircleLayer, historicCircleLayer, alertsIconLayer];
  }
}

AlertsLayer.layerName = 'AlertsLayer';
AlertsLayer.defaultProps = { visible: true, data: [] };

export default AlertsLayer;
